var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareRoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 24C576 37.25 565.25 48 552 48H338.906L231.344 493.625C228.938 503.531 220.531 510.875 210.406 511.875C209.594 511.969 208.781 512 208 512C198.75 512 190.219 506.656 186.25 498.156L80.719 272H24C10.75 272 0 261.25 0 248S10.75 224 24 224H96C105.312 224 113.812 229.406 117.75 237.844L200.75 415.719L296.656 18.375C299.281 7.594 308.906 0 320 0H552C565.25 0 576 10.75 576 24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRoot);
export default __webpack_public_path__ + "static/media/square-root.b0fc9de319bde1af07d2dcf5de28a775.svg";
export { ForwardRef as ReactComponent };